module.exports = __webpack_public_path__ + "static/author-2-257b906155c6d6bdb667bd98992f6182.jpg";